<style scoped>
.process-list {
    /* position: absolute;
    top: 70px;
    left: 240px;
    right: 300px;
    width: calc(100% - 250px);
    height: calc(100% - 80px); */
    background: #fff!important;
    /* border-radius: 8px; */
    overflow-y: auto;
    /* padding: 20px;
    margin: 16px; */
}
.process-list .el-tabs, .search-box {
  margin: 0px 12px;
}

a{
  cursor: pointer;
}   
.process-box{
  padding: 0;
} 
.batch-radio{
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: 20px;
}
.batch-radio-title{
  flex-shrink: 0;
  margin-right: 10px;
}
.search-area-div {
  width: 60px;
}
.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 54px - 80px);
}
</style>
<template>
  <div class="content process-list" v-loading="fullscreenLoading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部流程" name="">
      </el-tab-pane>
      <el-tab-pane label="待处理" name="4"></el-tab-pane>
      <el-tab-pane label="已处理" name="2"></el-tab-pane>
      <el-tab-pane label="我收到的" name="3"></el-tab-pane>
      <el-tab-pane label="我发起的" name="1"></el-tab-pane>
    </el-tabs>
    <div class="search-area process-box">
      <div class="search-box">
        <el-row :gutter="24">
          <!-- <el-col :span="6">
            <div class="search-area-div ">公司名称：</div>
            <el-input v-model="page.tenantName" class="ipt-sty w70f" :clearable="true" placeholder="请输入公司名称"></el-input>
          </el-col> -->
          <el-col :span="6">
            <div class="search-area-div ">药企名称</div>
            <el-select
              v-model="page.tenantGuid"
              placeholder="请选择药企名称"
              class="ipt-sty w70f"
              size="mini"
              @change="tenantChange"
              filterable
            >
              <el-option
                v-for="item in tenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">部门名称</div>
            <el-select
              v-model="page.organisationGuids"
              placeholder="请选择部门名称"
              class="ipt-sty w70f"
              size="mini"
              clearable
              filterable
              multiple 
              collapse-tags
              @focus="getOrganisation()"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div ">发起人</div>
            <el-input size="mini" v-model="page.staffName" class="ipt-sty w70f" :clearable="true" placeholder="请输入发起人"></el-input>
          </el-col>
          <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
              {{ showMore ? '收起筛选' : '更多筛选' }}
            </el-button>
            <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="mini" type="danger" @click="empty()">清空</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6">
            <div class="search-area-div ">审批状态</div>
            <el-select size="mini" v-model="approveState" @change="selectApprovalState" placeholder="请选择" class="ipt-sty w70f" filterable clearable>
              <el-option v-for="item in approvalList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">审批时间</div>
            <el-date-picker size="mini" class="ipt-sty w70f" v-model="timeI" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">提交时间</div>
            <el-date-picker size="mini" class="ipt-sty w70f" v-model="time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">流程名称</div>
            <el-select size="mini" v-model="page.flowType" placeholder="请选择" class="ipt-sty w70f" filterable clearable>
              <el-option v-for="item in flowList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-input v-model="value" class="ipt-sty w70f" placeholder="请选择流程名称"></el-input
          > -->
          </el-col>
        </el-row>
      </div>
      <div class="button-area">
        <el-button size="mini" type="info" @click="bitchExport" >批量导出</el-button>
        <el-button size="mini" type="borderBlack" @click="toBatchDown" v-show="page.flowType == '00003'">批量下载附件</el-button>
        <!-- <el-button size="mini" type="info" @click="toBatchAudit">批量审核</el-button> -->
      </div>
      <div class="content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="height:100%">          
        <el-table :data="tableData" :height="tableHeight" stripe border v-loading="tableLoading" style="width: 100%;"  @sort-change="sortChange">
          <el-table-column label="序号" width="70" header-align="center" align="center">
            <template slot-scope="scope">
              {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left" min-width="150"  prop="tenantName" label="公司名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column header-align="center" align="left"  prop="flowName" label="流程名称" show-overflow-tooltip width="130">
            <!-- <template slot-scope="scope">
              {{scope.row.flowType | flowType}}
            </template> -->
          </el-table-column>
          <el-table-column header-align="center" align="left" width="100"  prop="staffName" label="发起人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column header-align="center" align="left" min-width="150"  prop="organisationName" label="所在部门" show-overflow-tooltip>
          </el-table-column>
          <el-table-column header-align="center" align="left" min-width="150" prop="positionName" label="所在岗位" show-overflow-tooltip>
          </el-table-column>
          <el-table-column header-align="center" align="left"   prop="param4" label="负责人" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{scope.row.flowType == '00002'? scope.row.param4 : '-'}}
            </template>
          </el-table-column>
          <el-table-column  header-align="center" align="left"  prop="date" label="审批时间" width="150" sortable="custom">
            <template slot-scope="scope">
              {{scope.row.approveTime | getTime}}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left"  prop="date" label="提交时间" width="150" sortable="custom">
            <template slot-scope="scope">
              {{scope.row.createTime | getTime}}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left"  prop="name" label="审批状态" width="100">
            <template slot-scope="scope">
              <p class="fontC-red" v-if="scope.row.approveState == 'R'">已驳回</p>
              <p class="fontC-4fa1a4" v-if="scope.row.approveState == 'Y'">已通过</p>
              <p v-if="scope.row.approveState == 'N' || scope.row.approveState == 'A'">审批中</p>
              <p class="fontC-bbb" v-if="scope.row.approveState == 'C'">已撤销</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" header-align="center" fixed="right" align="center">
            <template slot-scope="scope">
              <a class="fontC-4fa1a4" @click="toDetail(scope.row.flowType, scope.row)">详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 30, 50]" :current-page="page.pageIndex" :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="dialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量审核" :visible.sync="dialogBatch" width="400px" top="15%" :close-on-click-modal="false">
      <div class="batch-radio">
        <div class="batch-radio-title">审核类型：</div>
        <el-radio v-model="batchRadio" label="Y">通过</el-radio>
        <el-radio v-model="batchRadio" label="N">驳回</el-radio>
      </div>
      <el-input type="textarea" :rows="5" placeholder="请填写审核原因" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f"  @click="toSubmitAudit()" :loading="btnLoading" >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        showMore: false, // 筛选项显示更多，默认否，最多显示三个
        tableHeight: window.innerHeight - 300,
        activeName: '',
        value:'',
        value1:'',
        value2:'',
        time:[],
        timeI:[],
        approvalList:[
          {label:'全部',value:''},
          {label:'审批中',value:'W'},
          {label:'已通过',value:'Y'},
          {label:'已驳回',value:'R'},
          {label:'已撤销',value:'C'},
        ],
        flowList:[
          {label:'全部',value:""},
          {label:'会议任务申请',value:"00001"},
          {label:'线上会议执行2',value:"00002"},
          {label:'会议任务总结',value:"00003"},
          {label:'潜在客户信息申请4',value:"00004"}
        ],
        approveState:'',
        tableData: [],
        page:{
          pageIndex: 1,
          tenantGuid: '',
          pageSize: 10,
          totalPage:0,
          totalRows:0,
          staffGuid: '',
          listType: 0,
          flowType: '',
          approveState:'',
          approveState1:'',
          staffName:'',
          tenantName:'',
          flowTypeList:['00001','00002','00003','00004'],
          startTime:'',
          endTime:'',
          startApproveTime:null,
          endApproveTime:null,
          orderByName:'create_time',//create_time/approve_time
          orderByType:'desc',//desc/asc
          organisationGuids:[]
        }, 
        approveSuggest:"",
        tableLoading:false,
        dialogVisible:false,
        dialogVisiblePass:false,
        rejectGuid:'',
        rejectFlowType:'',
        fullscreenLoading:false,
        passGuid: '',
        passFlowType: '',
        approveStaffGuid:'',//审核人guid
        currentStaffGuid:'',
        value:'',
        multipleSelection:[],
        dialogBatch:false,
        batchRadio:'',
        btnLoading:false,
        organisationList:[],
        tenantList:[]
      };
    },
    watch: {
      showMore(val, oldVal) {
        if(val) {
          this.tableHeight = window.innerHeight - 350;
          return;
        }
        if(!val) {
          this.tableHeight = window.innerHeight - 300;
          return;
        }
      },
    },
    created(){
      let userinfo = JSON.parse(localStorage.userInfo);
      this.currentStaffGuid = userinfo.staffGuid;
      this.getToday();
      this.getFlowType();
      this.getTenantList();
    },
    methods: {
      selected(row, index) {
        if (row.approveStaffGuid == this.page.staffGuid&&row.approveState !== 'Y' && row.approveState !== 'R' && row.approveState !== 'C') {
          return true 
        } else {
          return false; 
        }
      },
      //获取流程类型
      getFlowType() {
        let that = this;
        that.api.get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=LC-LCMC`
        ).then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            console.log(data);
            if(data&&data.length>0){
              let arr = [{label:'全部',value:""}];
              let arrNew = [];
              data.forEach((item) => {
                let obj = {
                  value: item.parameterValue,
                  label: item.name,
                };
                arr.push(obj);
                arrNew.push(item.parameterValue)
              });
              that.flowList = arr;
              that.page.flowTypeList = arrNew;
            }else{
              that.flowList = [];
              that.page.flowTypeList = ['00005']
            }
            that.getData();
          } else {
            that.getData();
            that.$message.error(res.data.msg);
          }
        });
      },
      //排序-时间
      sortChange(column) {
        this.page.orderByType = column.order == 'ascending'?'asc':'desc';
        console.log(column)
        if (column.column.label == "审批时间") {
          this.page.orderByName = 'approve_time';    
        } else if (column.column.label == "提交时间"){
          this.page.orderByName = 'create_time';
        }else{
          this.page.orderColumn = '';
          this.page.orderByType = '';
        }
        this.getData()// 查询列表方法
      },
      //获取药企
      getTenantList() {
        let self = this;
        let query = {
          isService: true,
          tenantGuid: localStorage.guid,
        };
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data || [];
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      tenantChange(val){
        if(val){
          this.getOrganisationList(val);
        }
      },
      //获取组织
      getOrganisationList(v) {
        let self = this;
        let query = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid:v,
          sendTenantGuid:localStorage.guid,
        }
        self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data.records || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      getOrganisation() {
        if (!this.page.tenantGuid ) {
          this.$message.error('请选择药企名称后再选择部门!');
          return;
        }
      },
      //批量导出
      bitchExport(){
        let self = this;
        if(self.page.flowType){
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/flow/data/export-flow-report`, self.page).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.reportJx(res.data.data.colNames,res.data.data.datas,res.data.data.sheetName,res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        }else{
          self.$message.warning('请选择流程名称！');
        }
    }, 
    reportJx(colNames,datas,sheetName,fileNam){
      let self = this; 
      self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`,{'colNames':colNames,'datas':datas,'sheetName':sheetName,'fileNam':fileNam})
      .then(res => {  
          let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
      });
    }, 
      getToday() {
        let date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        var time1 = year + "-" + month + "-" + "01";
        var time2 = year + "-" + month + "-" + day;
        this.time = [time1,time2]
      },
      getData(flg){
        let self = this;
        if (flg) {
          self.page.pageIndex = 1;  
        }
        if(self.time && self.time.length>0){
          self.page.startTime = self.time[0]+' '+'00:00:00';
          self.page.endTime = self.time[1]+' '+'23:59:59';
        }else{
          self.page.startTime = null;
          self.page.endTime = null;
        }
        if(self.timeI && self.timeI.length>0){
          self.page.startApproveTime = self.timeI[0]+' '+'00:00:00';
          self.page.endApproveTime = self.timeI[1]+' '+'23:59:59';
        }else{
          self.page.startApproveTime = null;
          self.page.endApproveTime = null;
        }
        self.tableLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/get-flow-list`, self.page).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows; 
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      empty(){
        let self = this;
        self.approveState = '';
        console.log(self.page.listType)
        if(self.page.listType == 4){
          self.page = {
            pageIndex: 1,
            tenantGuid: '',
            pageSize: 10,
            totalPage:0,
            totalRows:0,
            staffGuid: JSON.parse(localStorage.userInfo).staffGuid,
            listType: self.page.listType,
            flowType: '',
            approveState:'N',
            approveState1:'A',
            staffName:'',
            tenantName:'',
            flowTypeList:self.page.flowTypeList,
            startTime:'',
            endTime:'',
            startApproveTime:null,
            endApproveTime:null,
            orderByName:self.page.orderByName,//create_time/approve_time
            orderByType:self.page.orderByType,//desc/asc
            organisationGuids:[]
          }
        }else if(self.page.listType == 0){
          self.page = {
            pageIndex: 1,
            tenantGuid: '',
            pageSize: 10,
            totalPage:0,
            totalRows:0,
            staffGuid: '',
            listType: self.page.listType,
            flowType: '',
            approveState:'',
            approveState1:'',
            staffName:'',
            tenantName:'',
            flowTypeList:self.page.flowTypeList,
            startTime:'',
            endTime:'',
            startApproveTime:null,
            endApproveTime:null,
            orderByName:self.page.orderByName,//create_time/approve_time
            orderByType:self.page.orderByType,//desc/asc
            organisationGuids:[]
          }
        }else{
          self.page = {
            pageIndex: 1,
            tenantGuid: '',
            pageSize: 10,
            totalPage:0,
            totalRows:0,
            staffGuid: JSON.parse(localStorage.userInfo).staffGuid,
            listType: self.page.listType,
            flowType: '',
            approveState:'',
            approveState1:'',
            staffName:'',
            tenantName:'',
            flowTypeList:self.page.flowTypeList,
            startTime:'',
            endTime:'',
            startApproveTime:null,
            endApproveTime:null,
            orderByName:self.page.orderByName,//create_time/approve_time
            orderByType:self.page.orderByType,//desc/asc
            organisationGuids:[]
          }
        }
        self.timeI = [];
        self.time = [];
        self.getData();
      },
      selectApprovalState(value){
        if(value == 'W'){
          this.page.approveState = 'N';
          this.page.approveState1 = 'A';
        }else{
          this.page.approveState = value;
          this.page.approveState1 = '';
        }
      },
      handleClick(tab, event) {
        console.log(tab, event);
        let self = this;
        self.page.listType = Number(tab.name);
        if(tab.name == 4 || self.approveState == 'W'){
          self.page.approveState = 'N';
          self.page.approveState1 = 'A';
        }else{
          self.page.approveState = self.approveState;
          self.page.approveState1 = '';
        }
        if(tab.name == ''){
          self.page.staffGuid = '';
        }else{
          self.page.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
        }
        this.getData();
      },
    
      toDetail(flowType,row) {
        let self = this;
        sessionStorage.clear()
        let query = {
          guid: row.guid,
          bizGuid:row.bizGuid,
          tenantName:row.tenantName,
          approveStaffGuid: row.approveStaffGuid,
          organisationName:row.organisationName,
          camundaInstanceId:row.camundaInstanceId,
          camundaDeploymentId:row.camundaDeploymentId,
          productGuid:this.$route.query.productGuid
        }
        if (flowType == '00001') {
          this.$router.push({
            path: '/approvalDetail',
            query:query
          });
        } else if (flowType == '00002') {
          this.$router.push({
            path: '/onlineDetail',
            query:query
          });
        }else if(flowType == '00003'){
          this.$router.push({
            path: "/reimbursementDetail",
            query:query
          });
        }else if(flowType == '00004'){
          this.$router.push({
            path: "/customerDetail",
            query: query
          });
        }else if(flowType == '00005'){
          query.academicActivityPlanTitle = JSON.parse(row.param4).academicActivityPlanTitle;
          this.$router.push({
            path: "/academicDetail",
            query: query
          });
        }else if(flowType == '00006'){
          this.$router.push({
            path: "/pharmacyPageDetail",
            query: query
          });
        }else if(flowType == '00007'){
          this.$router.push({
            path: "/pharmacyPageEditDetail",
            query: query
          });
        }
      },
      //批量下载附件
      toBatchDown(){
        let self = this;
        let query = JSON.parse(JSON.stringify(self.page));
        query.pageSize = -1;
        query.appSideType = '1';
        query.approveState = 'Y';
        self.api.postJson(`/${serverConfig.msSalesPerformService}/flow/data/download-attachment`, query).then(res => {
            self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(res.data.data.files && res.data.data.files.length > 0){
              self.downZipJx(res.data.data.packageName ,res.data.data.files);
            }else{
              self.$message.warning('暂无附件下载！');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      downZipJx(packageName,files){
        let self = this; 
        self.fullscreenLoading = true;
        self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/zip/download-temp-file`,{packageName,files})
        .then(res => {  
          self.fullscreenLoading = false;
          let blob = new Blob([res.data], {type: "application/zip"});
          let fileName = '会议任务总结报告_' + this.$moment(new Date()).format("YYYYMMDDHHmmss");
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        }).catch(()=>{
          self.fullscreenLoading = false;
        });
      }, 
      handleSizeChange(val) {
        let self = this;
        self.page.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) { 
        let self = this;
        self.page.pageIndex = val;
        this.getData();
      }
    }
  };
</script>